<script>
import options from './TeamListCard.options'
export default options
</script>

<template>
    <a :href="url" class="kb-team-list-card">
      <section class="kb-team-list-card__image-container">
        <img :src="imageUrl" :alt="imageAlt" />
      </section>
      <section class="kb-team-list-card__content">
        <p class="kb-team-list-card__content-captain">
          {{ captainText }}
          <template v-for="(captain, index) in captains" :key="index">
            <span
              >{{ captain }}{{ index + 1 < captains.length ? ', ' : '' }}</span
            >
          </template>
        </p>

        <h2 class="kb-team-list-card__content-team">{{ name }}</h2>

        <div class="kb-team-list-card__content-fundraise-container">
          <p class="kb-team-list-card__content-price">
            {{ `${donationTotalFormatted } ${currencyText}` }}
          </p>
          <div class="kb-team-list-card__progress-bar">
            <div
              class="kb-team-list-card__progress-bar-inner"
              :class="{ full: progress === 100 }"
              :style="'width: ' + progress + '%'"
            ></div>
          </div>
          <p class="kb-team-list-card__content-target">
            {{ `${donationGoalsText} ${donationGoalsFormatted} ${currencyText}` }}
          </p>
        </div>

        <div class="kb-team-list-card__tag">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd"              clip-rule="evenodd"              d="M4.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 6.15c0-1.203.91-2.15 2-2.15 1.09 0 2 .947 2 2.15v2.85h.5V9.993A2.496 2.496 0 0 1 13 7.5c1.381 0 2.5 1.117 2.5 2.493V13h-1v.5H16V9.993A2.996 2.996 0 0 0 13 7a3 3 0 0 0-2.898 2.216C9.66 8.488 8.89 8 8 8c-.889 0-1.66.488-2.102 1.216A3 3 0 0 0 3 7C1.344 7 0 8.34 0 9.993V13.5h1.5V13h-1V9.993A2.496 2.496 0 0 1 3 7.5c1.381 0 2.5 1.117 2.5 2.493V13.5H6v-2.85ZM13 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 .5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-3.75-.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" fill="#3C3C3C"/></svg>
          <p>{{ `${membersCount} ${participantsText}` }}</p>
        </div>
      </section>
    </a>
</template>
